// src/components/Header.js
import React, { useState } from "react";
import { NavLink } from "react-router-dom";

// Inline style objects to mirror original CSS
const ulStyle = {
  listStyle: 'none',
  paddingLeft: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
const liStyle = { margin: '0 15px' };
const linkStyle = { textDecoration: 'none', color: '#000', fontWeight: 500 };

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(open => !open);

  return (
    <header className="site-header optech-header-section optech-header-one" id="sticky-menu">
      {/* top bar */}
      <div className="optech-header-top">
        <div className="container">
          <div className="optech-header-info-wrap">
            <div className="optech-header-info">
              <ul>
                <li><i className="ri-map-pin-2-fill" /> 2nd floor, Haridwar Bypass Rd, Dehradun, India, 248001</li>
              </ul>
            </div>
            <div className="optech-header-info">
              <ul>
                <li>
                  <a href="mailto:pm@raincorporated.com">
                    <i className="ri-mail-fill" /> pm@raincorporated.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* bottom nav */}
      <div className="optech-header-bottom">
        <div className="container">
          <div className="optech-header-bottom2">
            <nav className="navbar navbar-expand-md site-navbar d-flex align-items-center justify-content-between">
              {/* logo */}
              <div className="brand-logo">
                <NavLink to="/">
                  <img
                    src="/assets/images/logo/ra-logo.png"
                    alt="R.A. Inc. Logo"
                    className="light-version-logo"
                  />
                </NavLink>
              </div>

              {/* mobile toggle */}
              <button
                className="navbar-toggler d-md-none"
                type="button"
                onClick={toggleMenu}
                aria-label="Toggle menu"
              >
                <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} />
              </button>

              {/* menu (desktop always flex, mobile toggles) */}
              <div
                className={`collapse navbar-collapse menu-block-wrapper flex-grow-1 justify-content-center ${menuOpen ? 'show' : ''}`}
              >
                <nav className="menu-block" id="append-menu-header">
                  <ul className="site-menu-main mb-0" style={ulStyle}>
                    <li className="nav-item" style={liStyle}>
                      <NavLink to="/" className="nav-link-item" style={linkStyle}>Home</NavLink>
                    </li>
                    <li className="nav-item" style={liStyle}>
                      <NavLink to="/about-us" className="nav-link-item" style={linkStyle}>About Us</NavLink>
                    </li>

                    {/* Translation dropdown */}
                    <li className="nav-item nav-item-has-children" style={liStyle}>
                      
                      
                      <span className="nav-link-item drop-trigger" style={linkStyle}>
                      Translation <i className="ri-arrow-down-s-fill" />
                      </span>
                      <ul className="sub-menu">
                        <li className="sub-menu--item">
                          <NavLink to="/multimedia-and-dtp-services"><span className="menu-item-text">Multimedia & DTP Services</span></NavLink>
                        </li>
                        <li className="sub-menu--item">
                          <NavLink to="/audio-and-video-transcription"><span className="menu-item-text">Audio & Video Transcription</span></NavLink>
                        </li>
                        <li className="sub-menu--item">
                          <NavLink to="/subtitling"><span className="menu-item-text">Subtitling</span></NavLink>
                        </li>
                        <li className="sub-menu--item">
                          <NavLink to="/desktop-publishing-services"><span className="menu-item-text">Desktop Publishing Services</span></NavLink>
                        </li>
                        <li className="sub-menu--item">
                          <NavLink to="/multilingual-desktop-publishing"><span className="menu-item-text">Multilingual Desktop Publishing</span></NavLink>
                        </li>
                        <li className="sub-menu--item">
                          <NavLink to="/multimedia-and-dtp-tools"><span className="menu-item-text">Multimedia & DTP Tools</span></NavLink>
                        </li>
                      </ul>
                    </li>

                    {/* AI Services dropdown */}
                    <li className="nav-item nav-item-has-children" style={liStyle}>
                      <span className="nav-link-item drop-trigger" style={linkStyle}>
                        AI Services <i className="ri-arrow-down-s-fill" />
                      </span>
                      <ul className="sub-menu">
                        <li className="sub-menu--item">
                          <NavLink to="/data-annotation-services"><span className="menu-item-text">Data Annotation Services</span></NavLink>
                        </li>
                        <li className="sub-menu--item">
                          <NavLink to="/chat-prompt-optimization"><span className="menu-item-text">Chat Prompt Optimization</span></NavLink>
                        </li>
                        <li className="sub-menu--item">
                          <NavLink to="/image-processing-and-labeling"><span className="menu-item-text">Image Processing And Labeling</span></NavLink>
                        </li>
                        <li className="sub-menu--item">
                          <NavLink to="/chatbot-training-and-testing"><span className="menu-item-text">Chatbot Training & Testing</span></NavLink>
                        </li>
                        <li className="sub-menu--item">
                          <NavLink to="/image-localization-editing-and-retouching"><span className="menu-item-text">Image Localization, Editing & Retouching</span></NavLink>
                        </li>
                        <li className="sub-menu--item">
                          <NavLink to="/immersive-technologies"><span className="menu-item-text">Immersive Technologies</span></NavLink>
                        </li>
                      </ul>
                    </li>

                    <li className="nav-item" style={liStyle}>
                      <NavLink to="/languages" className="nav-link-item" style={linkStyle}>Languages</NavLink>
                    </li>
                    <li className="nav-item" style={liStyle}>
                      <NavLink to="/industry" className="nav-link-item" style={linkStyle}>Industry</NavLink>
                    </li>
                    <li className="nav-item" style={liStyle}>
                      <NavLink to="/faq" className="nav-link-item" style={linkStyle}>FAQ</NavLink>
                    </li>
                    <li className="nav-item" style={liStyle}>
                      <NavLink to="/contact-us" className="nav-link-item" style={linkStyle}>Contact Us</NavLink>
                    </li>
                  </ul>
                </nav>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;